export const en = {
    'banners-count': {
        one: '{count} ad',
        some: '{count} ads',
        many: '{count} ads',
        none: ''
    }
};
